import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import icon from './components/icon'
import Promise from 'promise-polyfill'
import BookingFormHelper from './BookingFormHelper'

if (!global._babelPolyfill) {
  require('babel-polyfill')
}

// To add to window
if (!window.Promise) {
  window.Promise = Promise
}

Vue.use(VueAxios, axios)
Vue.use(icon)

Vue.config.productionTip = false

window.DMN = window.DMN || {}

if (!window.DMN.BookingFormHelper) {
  window.DMN.BookingFormHelper = new BookingFormHelper()
}

window.DMN.BookingFormHelper.findBookingFormScriptTags()



// WEBPACK FOOTER //
// ./src/main.js